export default "__VITE_ASSET__$yQ6myRk__";